import { Component, inject } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Component({
	selector: 'app-charger-layout',
	imports: [RouterOutlet, MatTabsModule, RouterLink, RouterLinkActive, MatTooltip],
	templateUrl: './charger-layout.component.html',
	styleUrl: './charger-layout.component.scss'
})
export class ChargerLayoutComponent {
	isInstallerDSO = false;

	private authService = inject(AuthService);

	async ngOnInit() {
		this.isInstallerDSO = await this.authService.isInstallerDSO();
	}

}
